import axios from "axios";

import { ENDPOINT } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { hasUsableJWT } from "../../utils/authentication/hasUsableJWT";

export async function getBookedFlightAndHotelSummaryAPI(accessJWT: string, payload: any) {
  const URL = `${ENDPOINT}/app/v1/trips/summary`;
  let config = getHeaderConfig(null, accessJWT);
  let body = {
    ...payload,
  };
  if (!hasUsableJWT(accessJWT, "getBookedFlightAndHotelSummaryAPI")) return null;
  try {
    consoleLog(["BOOKED FLIGHT AND HOTEL SUMMARY API PAYLOAD", body]);
    const response = await axios.post(URL, encryptData(body), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      consoleLog(["BOOKED FLIGHT AND HOTEL SUMMARY API RESPONSE", JSON.parse(decryptedData)]);
      return decryptedData ? JSON.parse(decryptedData) : null;
    } else return null;
  } catch (error: any) {
    if (error.response) {
      return { statusCode: error.response.status, data: error.response.data };
    } else if (error.request) {
      consoleLog(["No response received", error.request]);
    } else {
      consoleLog(["Error setting up request", error.message]);
    }
    return null;
  }
}
